<template lang="pug">
  .sceneBox
    ul
      li(:class="[flag2==true?'bounceInDown':'']")
        .introduction
          h4 疫情防控
          p 疫情防控主要用于学校、社区办公场景，进行人员登记、排查记录导出...
          a(href="javascript:;" @click="viewDetails") 查看详情
        img(src="https://file.s5yun.com/resources/appico/16155115160902636_jiejue.jpeg" alt="")
      li(:class="[flag2==true?'bounceInUp':'']")
        img(src="https://file.s5yun.com/resources/appico/16155115415028842_企业.jpeg" alt="")
        .introduction
          h4 企业
          p 企业主要用于突破传统纸质汇报和审批的的管理体制和模式，加快信息...
          a(href="javascript:;" @click="details(1)") 查看详情
      li(:class="[flag2==true?'bounceInDown':'']")
        .introduction
          h4 教育行业
          p 工作人员远程监控管理，解决数据孤岛问 题，并可将重复出现的报警...
          a(href="javascript:;" @click="details(2)") 查看详情
        img(src="https://file.s5yun.com/resources/appico/16155115275414654_教育.png" alt="")
      li(:class="[flag2==true?'bounceInUp':'']")
        img(src="https://file.s5yun.com/resources/appico/16155115464525873_政府.JPG" alt="")
        .introduction
          h4 政府部门
          p 县域治理是推进国家治理体系和治理能力现代化的重要一环、一个县...
          a(href="javascript:;" @click="details(3)") 查看详情
    //.page
      ul
        li(@click="backPage") <
        li(:class="[flag1==1?'bc-blue':'']" @click="pageOne") 1
        li(:class="[flag1==2?'bc-blue':'']" @click="pageTwo") 2
        li(:class="[flag1==3?'bc-blue':'']" @click="pageThree") 3
        li(:class="[flag1==4?'bc-blue':'']" @click="pageFour") 4
        li(:class="[flag1==5?'bc-blue':'']" @click="pageFive") 5
        li( @click="nextPage") >
</template>

<script>
export default {
  data () {
    return {
      flag1: 1,
      flag: 1,
      flag2: false
    }
  },
  methods: {
    scene () {
      this.flag = 1
    },
    industryCase () {
      this.flag = 2
    },
    backPage () {
      if (this.flag1 !== 1) {
        this.flag1 = this.flag1 - 1
      }
    },
    nextPage () {
      if (this.flag1 !== 5) {
        this.flag1 = this.flag1 + 1
      }
    },
    pageOne () {
      this.flag1 = 1
    },
    pageTwo () {
      this.flag1 = 2
    },
    pageThree () {
      this.flag1 = 3
    },
    pageFour () {
      this.flag1 = 4
    },
    pageFive () {
      this.flag1 = 5
    },
    viewDetails () {
      window.scroll(0, 0)
      this.$router.push('/details')
    },
    details (index) {
      window.scroll(0, 0)
      var obj = { id: index }
      this.$router.push({ path: 'detailsother', query: obj })
    },
    handleScroll () {
      console.log(window.pageYOffset)
      if (window.pageYOffset >= 80) {
        this.flag2 = true
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    document.title = '速云官网'
  }
}
</script>

<style lang="less" scoped>
  .sceneBox{
    width: 100%;
    height: 620px;
    border-top: 1px solid #E6E6E6;
    padding: 62px 0;
    ul{
      width: 70%;
      margin: 0 auto;
      height: 528px;
      overflow: hidden;
      li{
        float: left;
        width: 25%;
        height: 100%;
        background-color: #FAFAFA;
        transform: translateY(-2000px);
        .introduction{
          position: relative;
          height: 263px;
          margin: 0 27px;
          border-top: 1px solid #fafafa;
          h4{
            font-size: 24px;
            font-weight: 400;
            margin: 30px 0 20px;
          }
          p{
            height: 120px;
            line-height: 30px;
            color: #666;
          }
          a{
            display: inline-block;
            width: 110px;
            height: 36px;
            text-align: center;
            line-height: 36px;
            background-color: #ccc;
            color: #fff;
          }
          a:hover{
            background-color: #007BF9;
          }
        }
        .introduction::after{
          content: "";
          position: absolute;
          bottom: -7px;
          left: 50%;
          width: 14px;
          height: 14px;
          transform: translate(-50%, 0) rotate(45deg);
          background-color: #fafafa;
        }
        img{
          width: 100%;
          height: 264px;
        }
      }
      li:nth-child(even){
        background-color: #fff;
        transform: translateY(2000px);
        .introduction::after{
          top: -13px;
          background-color: #fff;
        }
      }
    }
    .page{
      margin-top: 62px;
      ul{
        width: 280px;
        height: 30px;
        margin: 0 auto;
        display: block;
        li{
          float: left;
          width: 28px;
          height: 28px;
          margin-right: 10px;
          text-align: center;
          line-height: 28px;
          border: 1px solid #E6E6E6;
          cursor: pointer;
          color: #999;
          background-color: #fff;
          transform: translateY(0px);
        }
        .bc-blue{
          background-color: #007BF9;
          color: #fff;
        }
        li:hover{
          background-color: #007BF9;
          color: #fff;
        }
      }
    }
  }
  // 动画
  .bounceInDown{
    animation: bounceInDown 2s ease forwards;
  }
  .bounceInUp{
    animation: bounceInUp 2s ease forwards;
  }
  // 向下弹跳进入
  @keyframes bounceInDown{
    0%{
      opacity:0;
      transform:translateY(-2000px);
    }
    60%{
      opacity:1;
      transform:translateY(30px);
    }
    80%{
      transform:translateY(-10px);
    }
    100%{
      transform:translateY(0px);
    }
  }
  // 向上弹跳进入
  @keyframes bounceInUp{
    0%{
      opacity:0;
      transform:translateY(2000px);
    }
    60%{
      opacity:1;
      transform:translateY(-30px);
    }
    80%{
      transform:translateY(10px);
    }
    100%{
      transform:translateY(0px);
    }
  }
</style>
